import ChartCard from './ChartCard'
import MiniArea from './MiniArea'
import MiniBar from './MiniBar'
import MiniProgress from './MiniProgress'
import Field from './Field'

const Charts = {
  MiniBar,
  MiniArea,
  MiniProgress,
  ChartCard,
  Field
}

export {
  Charts as default,
  MiniBar,
  MiniArea,
  MiniProgress,
  ChartCard,
  Field
}



// WEBPACK FOOTER //
// ./src/wbap-components/charts/index.js